import VerticalSliderDots from './VerticalSliderDots'
export default VerticalSliderDots
